import { useTranslation } from 'react-i18next';
import { AmountUtils, cn, CurrencyUtils, PaletteUtils } from '@shared/utils';
import type { AccountResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface AccountHeaderProps {
  className?: string;
  account: AccountResponse;
}

export const AccountHeader = (props: AccountHeaderProps) => {
  const { t } = useTranslation('accounts');

  return (
    <div className='flex justify-between'>
      <div className='flex flex-col gap-2 pl-5 pt-5'>
        <Text size='3xl'>{AmountUtils.transformToAmountWithCurrency(props.account.balance, props.account.currency)}</Text>
        <ul className='flex flex-col gap-1'>
          <Text tag='li' weight='medium' size='xs' color='secondary'>
            {props.account.name}
          </Text>
          <Text tag='li' weight='medium' size='xs' color='secondary'>
            {props.account.productName}
          </Text>
          <Text tag='li' weight='medium'>
            {props.account.name}
          </Text>
        </ul>
      </div>
      <div
        className={cn(
          'relative flex h-32 w-36 flex-none flex-col items-center justify-end overflow-hidden rounded-tr-sm pb-2 pl-9 pr-1 pt-4 text-center',
          'before:absolute before:bottom-[-2px] before:right-[calc(100%-2px)] before:z-[1] before:h-[150%] before:w-1/2 before:origin-bottom-right before:rotate-[20deg] before:border before:bg-white before:dark:bg-soft-black',
          PaletteUtils.isInsigniaPalette && 'bg-soft-black before:border-r-primary dark:bg-slate',
          PaletteUtils.isVcfcPalette && 'bg-primary dark:before:border-r-ice',
        )}
      >
        <div
          className={cn(
            'mb-1',
            'text-[58px] before:leading-[1] before:content-[attr(data-icon)]',
            'after:absolute after:bottom-[-28px] after:left-[7px] after:text-[104px] after:leading-[1] after:opacity-5 after:content-[attr(data-icon)]',
            PaletteUtils.isInsigniaPalette && 'before:text-primary after:text-primary',
            PaletteUtils.isVcfcPalette && 'before:text-white after:text-white',
          )}
          data-icon={CurrencyUtils.getSymbolByCode(props.account.currency)}
        />
        <Text weight='semibold' size='sm' color='white'>
          {t(`statuses.account.${props.account.status}`, { ns: 'common' })}
        </Text>
      </div>
    </div>
  );
};
